import { mainStory } from '../stories';
import { effectSystem } from './store';

export * from './store';

// run the main story
effectSystem.run(mainStory);
